import { UseDisclosureProps, useDisclosure } from '@chakra-ui/react'

// Wrapper for useDisclosure that returns the isOpen, onOpen, and onClose to reduce the
// number of lines at the top of a file that has several modals with confirmations for example

/**
 * useNamedDisclosure
 * @param props useDisclosureProps
 * @returns [isOpen, onOpen, onClose]
 */
export const useNamedDisclosure = (
    props?: UseDisclosureProps
): [boolean, () => void, () => void] => {
    const { isOpen, onOpen, onClose } = useDisclosure(props)

    return [isOpen, onOpen, onClose]
}
